const getters = {
  /* app */
  metadata: state => state.app.data,
  sidebar: state => state.app.sidebar,
  getSliderStateWidth: state => {
    return state.app.sidebar.sliderState === 'full' ? '200px' : '60px'
  },
  getApiValue: state => {
  	// 备不时之需
    // return "https://apureli.srs.lbslm.com"
    return ''
  },
  lockState: state => state.app.lock,
  /* permission */
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  /* user */
  nickname: state => state.user.nickname,
  token: state => state.user.token,
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  uid: state => state.user.uid,
  appid: state => state.app.appid,
  customDisplays: state => state.app.customDisplays
}
export default getters
